import { Injectable } from '@angular/core';
import {AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn} from "@angular/forms";
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService {
  /**
   * Validator to check if the input length is either 12 or 90 characters.
   */
  static asyncLengthValidator(min: number, max: number): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return new Observable((observer) => {

        const value = control.value;
        if (!value) {
          observer.next(null); // Allow empty values
          observer.complete();
          return;
        }

        const length = value.length;
        setTimeout(() => {
          // Mimic async operation
          if (length >= min || length <= max) {
            observer.next(null); // Valid
          } else {
            observer.next({ invalidLength: { valid: false, requiredLengths: [min, max] } }); // Invalid
          }
          observer.complete();
        }, 10); // Simulated delay
      });
    };
  }

  /**
   * Example: Validator to ensure a field contains only numbers.
   */
  static numericValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const isValid = /^\d+$/.test(value);
      return isValid
          ? null
          : { invalidNumeric: { valid: false, message: 'Only numeric values allowed.' } };
    };
  }

  lengthValidator(minLength: number, maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // If the field is empty, don't validate
      }
      const valueLength = control.value.length;
      if (valueLength < minLength || valueLength > maxLength) {
        return { lengthError: { requiredMinLength: minLength, requiredMaxLength: maxLength } };
      }
      return null; // Validation passed
    };
  }

  static asyncNumericValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const value = control.value;
      if (!value) return of(null); // Allow empty values

      return new Observable((observer) => {
        setTimeout(() => {
          // Simulating an async check
          const isValid = /^\d+$/.test(value);
          if (isValid) {
            observer.next(null); // Valid input
          } else {
            observer.next({ invalidNumeric: { valid: false, message: 'Only numeric values allowed.' } }); // Invalid input
          }
          observer.complete();
        }, 500); // Simulate delay
      });
    };
  }
}
